<template>
  <router-view></router-view>
</template>
<script>
export default {
  name: "SettingsView",
  props: {},
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  methods: {},
};
</script>
<style lang="scss" scoped></style>
